import CategoryListPage from "@/pages/category/components/CategoryListPage";
import { tvList } from "@/lib/media";

export default function TvCategory() {
  return (
    <CategoryListPage
      title="电视剧列表"
      description="聚焦热播剧集与口碑好剧，覆盖悬疑、都市、年代、古装等多种题材。支持按类型、年份、地区与集数筛选，帮你高效追剧。以下内容为影视资讯与内容介绍展示，不含真实播放资源。"
      breadcrumbLabel="电视剧"
      list={tvList}
      type="tv"
    />
  );
}